export default __webpack_public_path__ + "static/media/E03.3b92ffe0.mp3";